//these are public keys
export const REBILLY_PUBLICKEYS = {
    local: 'pk_sandbox_uSCFz8SZ9mExc-kc9rQvMNSo9TycKuS0PtOHoyO',
    prod: 'pk_live_bcB8awIEGclaiQcA_-08xouZstyl2bP5iH51a7P',
};
export const REBILLY_URLS = {
    local: 'https://api-sandbox.rebilly.com/v2.1',
    prod: 'https://api.rebilly.com/v2.1',
};
